/* eslint-disable */
type CrTimestamp = number;
type CrJson = any;
type CrBigInt = number;
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: GoodsPart
// ====================================================

export interface GoodsPart {
  browsing_type: UxBrowsingType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: OrderItemPart
// ====================================================

export interface OrderItemPart {
  /**
   * 브라우저 타입
   */
  browsing_type: BrowsingType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PdpProductPart
// ====================================================

export interface PdpProductPart {
  /**
   * 브라우저 타입
   */
  browsing_type: PdpBrowsingType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: OrderRecommendProductPart
// ====================================================

export interface OrderRecommendProductPart {
  /**
   * 앱 내 브라우징 타입
   */
  browsing_type: OrderBrowsingType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: InquiryBrowsingTypePart
// ====================================================

export interface InquiryBrowsingTypePart {
  browsing_type: InquiryBrowsingType | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * 브라우저 타입
 */
export enum BrowsingType {
  DETAIL_BROWSER = "DETAIL_BROWSER",
  INTERNAL_BROWSER = "INTERNAL_BROWSER",
  NATIVE_BROWSER = "NATIVE_BROWSER",
  NORMAL = "NORMAL",
  Z_BROWSER = "Z_BROWSER",
}

export enum InquiryBrowsingType {
  DETAIL_BROWSER = "DETAIL_BROWSER",
  INTERNAL_BROWSER = "INTERNAL_BROWSER",
  NATIVE_BROWSER = "NATIVE_BROWSER",
  NORMAL = "NORMAL",
  Z_BROWSER = "Z_BROWSER",
}

export enum OrderBrowsingType {
  DETAIL_BROWSER = "DETAIL_BROWSER",
  INTERNAL_BROWSER = "INTERNAL_BROWSER",
  NATIVE_BROWSER = "NATIVE_BROWSER",
  NORMAL = "NORMAL",
  Z_BROWSER = "Z_BROWSER",
}

export enum PdpBrowsingType {
  DETAIL_BROWSER = "DETAIL_BROWSER",
  INTERNAL_BROWSER = "INTERNAL_BROWSER",
  NATIVE_BROWSER = "NATIVE_BROWSER",
  NORMAL = "NORMAL",
  Z_BROWSER = "Z_BROWSER",
}

export enum UxBrowsingType {
  DETAIL_BROWSER = "DETAIL_BROWSER",
  INTERNAL_BROWSER = "INTERNAL_BROWSER",
  NATIVE_BROWSER = "NATIVE_BROWSER",
  NORMAL = "NORMAL",
  Z_BROWSER = "Z_BROWSER",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
